export default {
  hasConfigurations(state) {
    const { configurations } = state;
    return configurations && configurations.length > 0;
  },
};
